import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { INITIAL_SPORT_TYPE_ENUM, INITIAL_TOURNAMENT_TYPE } from '~/constant/ui.constant';
import { lg } from '~/modules/colorLog';
export class uiHelper {
    constructor(_ElectronService) {
        this._ElectronService = _ElectronService;
        this.buttonIsActive = true;
        this.isOnlyDeposit = false;
        this.oddType_PRE_Listener = new EventEmitter();
        this.oddType_PRE = ['RoM', 'OU', 'NG'];
        this.oddType_LIVE_Listener = new EventEmitter();
        this.oddType_LIVE = ['RoM', 'OU', 'NG'];
        this.sportEnum_Listener = new EventEmitter();
        this.sportEnum = INITIAL_SPORT_TYPE_ENUM;
        this.tournamentType_Listener = new EventEmitter();
        this.tournamentType = INITIAL_TOURNAMENT_TYPE;
        this.uniquetournament_Listener = new EventEmitter();
        this.typeOfListListener = new EventEmitter();
        this.statisticListener = new EventEmitter();
        this.liveTrackerListener = new EventEmitter();
        this.expandIdListener = new EventEmitter();
        this.getSportFixtureListener = new EventEmitter();
        this.changeSportFixture = new EventEmitter();
        this.changeSportFixtureSort = new EventEmitter();
        this.scoreBoxViewListener = new EventEmitter();
        this.scoreBoxView = false;
        this.liveFilteredDataListener = new EventEmitter();
        this.isDateTodayListener = new EventEmitter();
        this.isAdminScreenVisibleListener = new EventEmitter();
        this.isAdminScreenVisible = false;
        this.adminScreenState = 0;
        this.refreshAppListener = new EventEmitter();
        this.liveScrollChange = new EventEmitter();
        this.preScrollChange = new EventEmitter();
        this.SecondScreenIsActive = false;
        this.qrCodeListener = new EventEmitter();
        this.customerQrStatusListener = new EventEmitter();
        this.customerQrStatus = false;
        this.CustomerCardSatus = false;
        this.customerCardStatusListener = new EventEmitter();
        this.liveGoalListListener = new EventEmitter();
        this.liveTrackerModalCloseListener = new EventEmitter();
        this.idleResetListener = new EventEmitter();
        this.transactionModalListener = new EventEmitter();
        this.slipDuplicateModalListener = new EventEmitter();
        this.terminalConfig = {
            IsBetOn: false,
            IsCashout: false,
            IsLiveOn: false,
            IsSportOn: false,
            IsJacktimeActive: false,
            ShowCashoutButton: false,
            TemporaryBet: false,
            TerminalCongId: 1,
            TerminalId: 0,
            IsPINActive: true,
        };
        this.terminalConfigListener = new EventEmitter();
        this.barcodeCardModalEventListener = new EventEmitter();
    }
    informLanguageUpdate() {
        // todo Currently doesn't work.
    }
    setOddType_PRE(e, rowNumber) {
        this.oddType_PRE[rowNumber] = e;
        this.oddType_PRE_Listener.emit(this.oddType_PRE);
    }
    setAllOddType_PRE(oddTypes) {
        this.oddType_PRE = oddTypes;
        this.oddType_PRE_Listener.emit(this.oddType_PRE);
    }
    resetOddType_PRE() {
        this.oddType_PRE = ['RoM', 'OU', 'NG'];
        this.oddType_PRE_Listener.emit(this.oddType_PRE);
    }
    setOddType_LIVE(e, rowNumber) {
        this.oddType_LIVE[rowNumber] = e;
        this.oddType_LIVE_Listener.emit(this.oddType_LIVE);
    }
    resetOddType_LIVE() {
        this.oddType_LIVE = ['RoM', 'OU', 'NG'];
        this.oddType_LIVE_Listener.emit(this.oddType_LIVE);
    }
    setSportType(e) {
        this.sportEnum = e;
        this.sportEnum_Listener.emit(this.sportEnum);
        lg('SPORT TYPE', this.sportEnum.toString());
        this.getSportFixture();
    }
    setTournamentType(e) {
        this.tournamentType = e;
        this.tournamentType_Listener.emit(e);
        //lg('TOURNAMENT TYPE', this.tournamentType.toString());
    }
    setUniqueTournament(e) {
        // Puan Durumu için BetradarId geliyor
        this.uniquetournament = e;
        this.uniquetournament_Listener.emit(e);
    }
    setTypeOfList(e) {
        this.typeOfList = e;
        this.typeOfListListener.emit(this.typeOfList);
        //lg('SPORT TYPE', this.typeOfList.toString());
    }
    getSportFixture() {
        this.getSportFixtureListener.emit(true);
    }
    setChangeSportFixture() {
        this.changeSportFixture.emit(true);
    }
    setScoreBoxView(e) {
        this.scoreBoxView = e;
        this.scoreBoxViewListener.emit(this.scoreBoxView);
        lg('Score Box Activation:', this.scoreBoxView ? 'true' : 'false');
    }
    setExpandId(e) {
        this.expandId = e;
        this.expandIdListener.emit(this.expandId);
        lg('EXPAND ID');
    }
    setLiveFilteredData(e) {
        this.liveFilteredData = e;
        this.liveFilteredDataListener.emit(this.liveFilteredData);
        //lg('LIVE FILTERED DATA', this.liveFilteredData);
    }
    setRefreshApp() {
        this.refreshAppListener.emit(true);
    }
    setScrollChange(direction) {
        if (this.typeOfList === 'live') {
            this.liveScrollChange.emit(direction);
        }
        else if (this.typeOfList === 'pre') {
            this.preScrollChange.emit(direction);
        }
    }
    setDateTodayStatus(set) {
        this.isDateToday = set;
        this.isDateTodayListener.emit(this.isDateToday);
    }
    /*

state;
0: hidden
1: pass Screen
2: pass oK.

*/
    setAdminScreen(set, state) {
        this.isAdminScreenVisible = set;
        this.adminScreenState = state;
        this.isAdminScreenVisibleListener.emit(this.isAdminScreenVisible);
    }
    setStatisticModalParameter(e) {
        this.statisticListener.emit(e);
    }
    setLiveTrackerModalParameter(e) {
        this.liveTrackerListener.emit(e);
    }
    AllscreenButtonActive(state) {
        console.log('STATE----', state);
        this.buttonIsActive = state;
        console.log('this.buttonIsActive----', this.buttonIsActive);
    }
    OpenMoneyReader() {
        _sendChromeMessage({
            command: 'runmoneyreader',
        });
    }
    CloseMoneyReader() {
        _sendChromeMessage({
            command: 'haltmoneyreader',
        });
    }
    SetQrCode(e) {
        // console.log('SetQrCode_EMİT',e);
        this.qrCodeListener.emit(e);
    }
    SetCustomerQrStatus(e) {
        this.customerQrStatus = e;
        this.customerQrStatusListener.emit(e);
    }
    SendElectronMessage(command, arg) {
        if (this._ElectronService != null)
            if (this._ElectronService.isElectronApp) {
                this._ElectronService.ipcRenderer.send(command, arg);
            }
    }
    SetCustomerCardStatus(e) {
        this.CustomerCardSatus = e;
        this.customerCardStatusListener.emit(e);
    }
    // HEADER GOAL ANIMATION
    SetLiveGoalListData(e) {
        this.liveGoalList = e;
        this.liveGoalListListener.emit(e);
    }
    LivetrackerModalClose(e) {
        this.liveTrackerModalCloseListener.emit(e);
    }
    SetTerminalConfig(e) {
        this.terminalConfig = e;
        this.terminalConfigListener.emit(e);
        localStorage.setItem('tconfig', JSON.stringify(e));
        // // VorabTicket == 0 => MoneyReader Close
        // if (e.TemporaryBet == false || e.IsBetOn == false) {
        //     this.SendElectronMessage('electronListener', {
        //         type: 'moneyReader_control',
        //         money_reader_status: 'disable',
        //     });
        // } else {
        //     this.SendElectronMessage('electronListener', {
        //         type: 'moneyReader_control',
        //         money_reader_status: 'enable',
        //     });
        // }
    }
    SetTransactionModal(e) {
        this.transactionModalListener.emit(e);
    }
    SetSlipDuplicateModal(e) {
        this.slipDuplicateModalListener.emit(e);
    }
    SetBarcodeCardData(e) {
        this.barcodeCardModalEventListener.emit(e);
    }
    OpenBarcodeCardModal() {
        $('#BarcodeCardModal')
            .modal({
            detachable: false,
        })
            .modal('show');
    }
    CloseBarcodeCardModal() {
        $('#BarcodeCardModal')
            .modal({
            detachable: false,
        })
            .modal('hide');
    }
    //Luhn Algorithm ( Kart Numarası doğru mu ? )
    CardNoCheck(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Accept only digits, dashes or spaces
            if (/[^0-9-\s]+/.test(value))
                return false;
            // The Luhn Algorithm. It's so pretty.
            let nCheck = 0, bEven = false;
            value = value.replace(/\D/g, '');
            for (let n = value.length - 1; n >= 0; n--) {
                let cDigit = value.charAt(n), nDigit = parseInt(cDigit, 10);
                if (bEven && (nDigit *= 2) > 9)
                    nDigit -= 9;
                nCheck += nDigit;
                bEven = !bEven;
            }
            return nCheck % 10 == 0;
        });
    }
    setOnlyDeposit(status) {
        this.isOnlyDeposit = status;
    }
}
